import { useGetTicketingIntegrationsQuery } from "~/operations";
import { useCanCreateCase } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/CreateCase";
import { useScope } from "~/hooks/useScope";

export function useTicketingIntegrations() {
  const { spaceScope } = useScope();

  const hasCreateTicketPermissions = useCanCreateCase(spaceScope);

  const { data: ticketingIntegrationsData } = useGetTicketingIntegrationsQuery({
    variables: {
      input: {
        spaceMrn: spaceScope?.mrn || "",
      },
    },
    fetchPolicy: "cache-and-network",
    skip: !hasCreateTicketPermissions || !spaceScope,
  });

  const hasTicketingIntegration =
    (ticketingIntegrationsData?.ticketingIntegrations?.integrations?.length ||
      0) > 0;

  return {
    hasTicketingIntegration,
  };
}
